import { render } from "./BaseNavSecondary.vue?vue&type=template&id=2bc94168"
import script from "./BaseNavSecondary.vue?vue&type=script&lang=js"
export * from "./BaseNavSecondary.vue?vue&type=script&lang=js"

import "./BaseNavSecondary.vue?vue&type=style&index=0&id=2bc94168&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__